import { ActionType } from 'typesafe-actions';

import * as types from './types';
import * as actions from './actions';
import { Dataset, Project, Event } from '@interfaces/outreach-entity';

export type HomepageAction = ActionType<typeof actions>;

export interface OutreachState {
    readonly events: Event[];
    readonly projects: Project[];
    readonly datasets: Dataset[];
    readonly isLoading: boolean;
    readonly error?: boolean;
}

const initialState: OutreachState = {
    events: [],
    projects: [],
    datasets: [],
    isLoading: false,
    error: undefined
};

function reducer(state = initialState, action: HomepageAction): OutreachState {
    switch (action.type) {
        case types.FETCH_OUTREACH_PAGE:
            return fetchOutreach(state);

        case types.FETCH_OUTREACH_PAGE_SUCCESS:
            return fetchOutreachSuccess(state, action);

        case types.FETCH_OUTREACH_PAGE_ERROR:
            return fetchOutreachError(state, action);

        default:
            return state;
    }
}

function fetchOutreach(state: OutreachState) {
    return {
        ...state,
        isLoading: true,
        error: undefined
    };
}

function fetchOutreachSuccess(state: OutreachState, action: any) {
    const data = action.payload;

    return {
        ...state,
        ...data,
        isLoading: false,
        error: undefined
    };
}

function fetchOutreachError(state: OutreachState, action: any) {
    return {
        ...state,
        ...initialState,
        isLoading: false,
        error: action.payload
    };
}

export default reducer;
